const placeholder = "gfxp1w4b9hx";

export { placeholder };
import "./empty-image.style.linaria.module.css";
//# sourceMappingURL=empty-image.style.js.map
